import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { cloneDeep } from 'lodash';
/**
 * Generated class for the CustomBookinCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'custom-bookin-card',
  templateUrl: 'custom-bookin-card.html'
})
export class CustomBookinCardComponent {

  booking:any

  constructor(public navParams:NavParams) {
    this.booking = cloneDeep(navParams.get('event'));
    console.log(this.booking);
    
  }
}



// WEBPACK FOOTER //
// ./src/components/custom-bookin-card/custom-bookin-card.ts